import { Card } from "../../ui/card";
import { ErrorCard, Field, LoadingBlock } from "../AdminBits";
import useAdminFetch from "../../../hooks/useAdminFetch";
import { TRAINING_FIGURES, formatCount } from "../../../lib/jamoraAdmin";
import { formatDateTime } from "../../../lib/tickets";

// How much a pharmacy's team uses Jamora's training modules: counters only, never who watched what.
export default function TrainingTab({ schema }) {
  const { phase, data, error, reload } = useAdminFetch(`/pharmacies/${schema}/training-stats`);
  if (phase === "loading" || phase === "idle") return <LoadingBlock rows={3} />;
  if (phase === "error") return <ErrorCard message={error} onRetry={reload} />;
  return (
    <Card className="p-4" data-testid="pharmacy-training">
      <h2 className="text-sm font-semibold text-slate-900 mb-1">Formation — {data.period_days} derniers jours</h2>
      <dl className="divide-y divide-slate-100">
        {TRAINING_FIGURES.map(([key, label]) => <Field key={key} label={label}>{formatCount(data[key])}</Field>)}
        <Field label="Modules consultés">{formatCount(data.modules_seen)}</Field>
      </dl>
      <p className="text-xs text-slate-500 pt-2">Un parcours est dit abandonné après {data.abandon_after_days} jours sans suite. Calculé le {formatDateTime(data.computed_at)}.</p>
    </Card>
  );
}
